export default __webpack_public_path__ + "static/media/Matlab.90c9d2f2.svg";